// character count limit  greater than 450 extract it:
export const charLimit = (str, limit) => str && str.length > limit ? str.slice(0, limit) + '...' : str;
